<template style="height:100%">


  <div class="Test">
    <el-tabs v-model="activeName">
      <el-tab-pane label="团体档案" name="first">
        <Grouparchives />
      </el-tab-pane>
      <el-tab-pane label="个人档案" name="second">
        <Personalarchives />
      </el-tab-pane>

      <el-tab-pane label="档案追踪" name="third">
        <Trackarchives />
      </el-tab-pane>
    </el-tabs>





  </div>
</template>
<script>
import Grouparchives from './Grouparchives'
import Personalarchives from './Personalarchives'
import Trackarchives from './Trackarchives'

  export default {
    data() {
      return {
        ccfd:true,
        activeNames: ['1'],
        activeName: 'second',
        input1:'',
        value1:'',
        isActive: true,
        activeClass: 'Nac',
        errorClass: 'Nac2',
        formInline: {
          user: '',
          region: ''
        },
       
        checkboxGroup1: [],
     
        };
    },
    components:{
      Grouparchives,
      Personalarchives,
      Trackarchives,
    },
    methods: {
      handleChange(val) {
      },
      change(){
        this.isActive = !this.isActive;
      },
      onSubmit(){

      },
      handleEdit(index, row){
      },
      handleDelete(index, row){
      }
    }
  };
</script>